module.exports = __webpack_public_path__ + "img/37.b166cc78.png";